var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionsAdsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5670_25175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5051 13.6154L13.2149 2.72031C11.7968 0.264058 8.19692 0.274944 6.78509 2.72031L0.494797 13.6154C-0.919613 16.0652 0.87246 19.1177 3.66468 19.1177C4.91898 19.1177 6.15834 18.4745 6.8465 17.2825L9.99996 11.8205L13.1534 17.2825C13.8405 18.4726 15.079 19.1177 16.3352 19.1177C19.1256 19.1177 20.9203 16.0665 19.5051 13.6154ZM5.73332 16.6398C5.17811 17.6015 4.04942 18.0369 3.01014 17.7381C1.51768 17.3045 0.839522 15.589 1.60794 14.258C2.26606 13.1181 3.72128 12.7279 4.8615 13.3862C6.00152 14.0444 6.3916 15.4997 5.73332 16.6398ZM7.127 14.2259C6.52825 12.5254 4.77574 11.512 3.00167 11.8442L6.55307 5.69302C6.7113 6.1768 6.60015 5.93186 9.25789 10.5352L7.127 14.2259ZM17.5202 17.5116C16.3803 18.1698 14.9248 17.78 14.2666 16.6398L7.97636 5.74475C6.77605 3.66576 9.08995 1.30064 11.1518 2.49119C11.9234 2.93666 11.7111 2.68645 18.392 14.258C19.0486 15.3954 18.6575 16.855 17.5202 17.5116Z",
    fill: "white",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5670_25175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionsAdsIcon);
export default __webpack_public_path__ + "static/media/subscriptions-ads-icon.5513a5f9a1e43f6b4143ec0b7f2ac17a.svg";
export { ForwardRef as ReactComponent };